import { Button, Tooltip } from "antd";
import { useContext } from "react";
import { CalendarOutlined } from "@ant-design/icons";
import {
  LiveTrackIcon,
  ManualTrackIcon,
} from "../../../../../assets/icons/CustomIcons";
import { TrackerContext } from "./utils/types";
const TrackerModeSwitch = () => {
  const { typeOfTracking, switchTracker } = useContext(TrackerContext);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0,
        }}
      >
        <Tooltip title="Track time live" placement="left">
          <Button
            onClick={() => switchTracker("Auto")}
            style={{
              border: "none",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 22,
              minWidth: 24,
              padding: 0,
            }}
          >
            <span
              style={{
                display: "flex",
                width: 14,
                height: 14,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LiveTrackIcon
                color={typeOfTracking === "Auto" ? "#137AE9" : "#bbb"}
              />
            </span>
          </Button>
        </Tooltip>
        <Tooltip title="Track time manually" placement="left">
          <Button
            onClick={() => switchTracker("Manual")}
            style={{
              border: "none",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 22,
              minWidth: 24,
              padding: 0,
            }}
          >
            <span
              style={{
                display: "flex",
                width: 14,
                height: 14,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ManualTrackIcon
                color={typeOfTracking === "Manual" ? "#137AE9" : "#bbb"}
              />
            </span>
          </Button>
        </Tooltip>
        <Tooltip title="Track time on calendar" placement="left">
          <Button
            onClick={() => switchTracker("Calendar")}
            style={{
              border: "none",
              boxShadow: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 22,
              minWidth: 24,
              padding: 0,
            }}
          >
            <span
              style={{
                display: "flex",
                width: 14,
                height: 14,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CalendarOutlined
                style={{
                  fontSize: 14,
                  color: typeOfTracking === "Calendar" ? "#137AE9" : "#bbb",
                }}
              />
            </span>
          </Button>
        </Tooltip>
      </div>
    </>
  );
};
export default TrackerModeSwitch;
